import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  WalletIcon,
  MinerIcon,
  HistoryIcon,
  SettingsIcon,
} from './icons.js';

interface TabConfig {
  to: string;
  matchPrefix?: string;
  labelKey: string;
  icon: (props: { className?: string }) => ReactNode;
}

const TABS: TabConfig[] = [
  { to: '/wallet', labelKey: 'tabs.wallet', icon: WalletIcon },
  { to: '/miner', labelKey: 'tabs.miner', icon: MinerIcon },
  { to: '/history', labelKey: 'tabs.history', icon: HistoryIcon },
  {
    to: '/settings',
    matchPrefix: '/settings',
    labelKey: 'tabs.settings',
    icon: SettingsIcon,
  },
];

export function BottomTabBar(): ReactNode {
  const { t } = useTranslation();
  return (
    <nav aria-label="Primary" className="fixed inset-x-0 bottom-0 z-40">
      {/* Inner div carries the chrome (border-t, bg, safe-area pad) so
       * the visible bar matches the clamped #root column on desktop and
       * the body gradient shows through on either side. On mobile and
       * Telegram WebView (viewport ≤ 480px) the max-w is a no-op — same
       * appearance as before this commit. */}
      <div
        className="mx-auto w-full max-w-[480px] border-t border-border-hairline bg-bg backdrop-blur"
        style={{
          paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 8px)',
        }}
      >
        <ul className="flex items-stretch justify-around">
          {TABS.map((tab) => {
          const Icon = tab.icon;
          return (
            <li key={tab.to} className="flex-1">
              <NavLink
                to={tab.to}
                end={!tab.matchPrefix}
                className={({ isActive }) =>
                  [
                    'flex flex-col items-center gap-1 py-2 text-[10px] font-medium transition-colors',
                    isActive
                      ? 'text-text-primary font-semibold'
                      : 'text-text-secondary hover:text-text-primary',
                  ].join(' ')
                }
              >
                <Icon className="h-5 w-5" />
                <span>{t(tab.labelKey)}</span>
              </NavLink>
            </li>
          );
        })}
        </ul>
      </div>
    </nav>
  );
}
